<template>
  <div class="step">
    <h2>
      {{ step.StepNumber + ' | ' + step.StepTitle }}
    </h2>
    <div class="step--description">
      <div
        class="item"
        v-if="step.StepImage && step.StepImage.mime.includes('video')"
      >
        <div class="step--description--video">
          <video
            controls
          >
            <source
              :src="step.StepImage.url"
              type="video/mp4"
            >
            <track
              kind="subtitles"
            >
          </video>
        </div>
      </div>
      <responsive-image
        v-if="step.StepImage && step.StepImage.mime.includes('image')"
        :picture="step.StepImage"
        class="item item--image"
      />
      <Markdown
        :text="step.StepDescription"
        class="item item--description"
      />
    </div>
  </div>
</template>

<script>
import responsiveImage from '../responsive-image.vue'

export default {
  name: 'Step',
  components: {'responsive-image': responsiveImage},
  props: {
    step: {
      type: Object || null,
      default () {
        return []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.step {
  &--description {
    display: flex;
    flex-flow: row wrap;

    &--video {
      padding-right: $default-margin-padding-width;

      video {
        width: 100%;
      }
    }

    .item {
      flex: 50%;
    }

    p {
      font-weight: lighter;
      font-size: $base-text-font-size;
    }

    @media (max-width: $md) {
      flex-direction: column;
    }

    @include breakpoint-up($md) {
      .item {
        flex: calc(50% - .5rem);

        &--image {
          margin-right: .5rem;
        }

        &--description {
          margin-left: .5rem;
        }
      }
    }
  }
}
</style>
